import * as React from 'react';
import { RadioChipButton } from '../RadioChipButton';
import { ChipsGroup } from '../../../internal/components/Chip';
import { useId } from '../../../internal/hooks';
import { useRadioGroupOptions } from '../../../checkbox/internal';

/**
 * @deprecated использовать компонент Chips с пропсом selectType=oneOf
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var RadioChipsGroup = /*#__PURE__*/React.memo(function RadioChipsGroup(props) {
  var defaultValue = props.defaultValue,
    disabled = props.disabled,
    invalid = props.invalid,
    role = props.role,
    inline = props.inline,
    size = props.size,
    title = props.title,
    titleWeight = props.titleWeight,
    fullWidth = props.fullWidth,
    iconPosition = props.iconPosition,
    counterMaxLength = props.counterMaxLength,
    scrollable = props.scrollable;
  var options = useRadioGroupOptions(props);
  var name = useId(props.name);
  return /*#__PURE__*/_jsx(ChipsGroup, {
    title: title,
    size: size,
    titleWeight: titleWeight,
    role: role,
    inline: inline,
    fullWidth: fullWidth,
    scrollable: scrollable,
    children: options.map(function (_ref) {
      var value = _ref.value,
        label = _ref.label,
        onChange = _ref.onChange,
        icon = _ref.icon,
        counter = _ref.counter,
        checked = _ref.checked;
      var key = String(value);
      return /*#__PURE__*/_jsx(RadioChipButton, {
        // Приводится к строке, чтобы не ослаблять типы
        name: name,
        value: key,
        checked: checked,
        defaultChecked: defaultValue !== undefined ? defaultValue === value : undefined,
        disabled: disabled,
        invalid: invalid,
        label: label,
        onChange: onChange,
        role: role === 'listbox' ? 'option' : undefined,
        size: size,
        counterMaxLength: counterMaxLength,
        iconPosition: iconPosition,
        icon: icon,
        counter: counter,
        scrollInView: scrollable
      }, key);
    })
  });
});